const If = ({ condition = false, children }) => {
  if (condition) {
    return children;
  }
  return null;
};

export default If;
